import React from 'react';

import AddBtnMobile from './Common/AddBtnMobile';
import { HGCardBase, CardBodyTop } from './Common';

export default function FlightCard(props) {
  const { editable, cardData } = props;
  const { name } = cardData;
  return (
    <HGCardBase className="flightCard" cardData={cardData} editable={editable}>
      <CardBodyTop title={name} type="flights">
        <AddBtnMobile editable={editable} cardData={cardData} />
      </CardBodyTop>
    </HGCardBase>
  );
}



// WEBPACK FOOTER //
// ./src/components/Cards/FlightCard.jsx